import validateRequiredProps from 'utils/validateRequiredProps';
import getFullName from 'utils/getFullName';
import {Record} from 'immutable';

export function validate(contact) {
  return validateRequiredProps(contact, ['firstName', 'lastName']);
}

export default class CrmContact extends Record({
  id: null,
  firstName: null,
  lastName: null,
  email1: null,
  email2: null,
  cellPhone: null,
  workPhone: null,
  crmAccountId: null,
  name: null, // Not returned by the backend.
}) {
  constructor(object = {}) {
    super({
      ...object,
      name: getFullName(object) + ' <' + object.email1 + '>',
      id: object.id || object.crmId,
    });
  }
  getFullName() {
    return getFullName(this);
  }
}
